export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-2.cddbf5cc.png";